import {Component, EventEmitter, Input, Output} from '@angular/core';

import {BaseComponent} from '../../base-components/base.component';

@Component({
    selector: 'checkbox',
    templateUrl: './checkbox.html'
})

export class CheckboxComponent extends BaseComponent {
    @Input() checked: boolean;

    @Output() onChange: EventEmitter<any>;

    constructor() {
        super();
        this.onChange = new EventEmitter<any>();
    }

    ngOnInit() {

    }

    onClick(checked) {
        this.onChange.emit(checked);
    }
}
